import { apiWrapper } from "apis/CommonApi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "utils/store";
import * as fireonApi from "../../apis/FireOnApi";
import { useEffect, useState } from "react";
import { getYear } from "utils/date";
import FireOnToolbar from "./FireOnToolbar";

//화재경보 통계표
export default function FireAlarmStatisticsComponent(props) {
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <>
            <div class="viewBoard fireOnBoard tableBoard overBtmBoard FASboard">
                <TopBoard currentDateTime={props.currentDateTime} />
                <MidBoard />
                <FireOnToolbar item="통계 레포트" buildingName={buildingName} serialNumber={serialNumber} dei={dei} />
            </div>
        </>
    );
}

const TopBoard = ({ currentDateTime }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();
    const location = useLocation();

    const handleGoBack = () => {
        navigate(`/fire-on/alarm-monitor/${id}`, location.state);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo" /> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <a className="set_contr" href="#">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </a>
                    </div>
                </div>
            </div>

            <div class="top_board navi_board">
                <div class="wrap_navi" >
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p class="title_navi">화재경보 통계표</p>
                </div>
                <div className="wrap_right pc">
                    <div className="wrap_userBox">
                        <div className="wrap_userInfo pc">
                            <p className="current_date">{currentDateTime}</p>
                        </div>
                        <p className="user_id">{userName}</p>
                    </div>
                </div>
                <div class="wrap_right mb">
                    <a class="btn_page_left" href="/fireAlarmStatistics_mb.html">
                        <i class="x-icon"></i>
                    </a>
                </div>
            </div>
        </>
    );
};

const MidBoard = () => {
    const location = useLocation();
    const { buildingName } = location.state;
    const [dataSource, setDataSource] = useState(null);
    const [searchText, setSearchText] = useState(getYear(new Date()));

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireAlarmStatistics(searchText);
            if (status === true) {
                setDataSource(data);
            } else {
                alert(`${data}`);
            }
        })
    }

    const handleChangeSearchText = (e) => {
        setSearchText(e.target.value);
    }

    const handleSearch = (e) => {
        if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
            if (isNaN(searchText) || searchText.length !== 4) {
                alert(`4자리 숫자 형식으로 입력해주세요.`);
            } else {
                getData();
            }
        }
    }

    const handleExportExcel = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.downloadExcelFireAlarmStatistics(searchText);
            if (status === false) {
                alert(`엑셀 저장에 실패하였습니다.\n${data}`);
            }
        });
    }

    return (
        <>
            <div class="mid_board">
                <div class="wrap_mid_le">
                    <p class="title_mid">{buildingName}</p>
                </div>
                <div class="wrap_right pc">
                    <div class="wrap_search openSearch">
                        <div class="box_search">
                            <div class="select_box">
                                <button class="btn_select">
                                    <p>검색 년도</p>
                                </button>
                            </div>
                            <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
                            <button class="btn_search" onClick={handleSearch}>
                                <i class="x-icon icon_search"></i>
                            </button>
                        </div>
                    </div>
                    <div class="wrap_item_contr">
                        <button class="btn_contr btn_add" onClick={handleExportExcel}>
                            엑셀
                        </button>
                    </div>
                </div>
            </div>

            {dataSource && (
                <TableBoard dataSource={dataSource} />
            )}
        </>
    );
};

const TableBoard = ({ dataSource }) => {
    return (
        <div class="table_board">
            <PartTable title="수신기 동작 유형별 통계" headTitle="수신기 동작 유형별" data={dataSource.eventMonthStats} />
            <PartTable title="이벤트 항목별 통계" headTitle="이벤트 항목별" data={dataSource.eventTypeStats} />
            <PartTable title="발생요일별 통계" headTitle="발생요일별 유형별" data={dataSource.weekdayStats} />
            <PartTable title="발생시간대별 통계" headTitle="발생시간대별 유형별" data={dataSource.hourStats} />
        </div>
    );
}

const PartTable = ({ title, headTitle, data }) => {
    return (
        <div class="wrap_table part_table">
            <p class="title_table">{title}</p>
            <div class="containerTable statisticsTable">
                <div class="inner_table">
                    <ul className="head_table">
                        <li>
                            <p>{headTitle}</p>
                        </li>
                        {Array.from({ length: 12 }, (_, i) => (
                            <li key={i}>
                                <p>{i + 1}월</p>
                            </li>
                        ))}
                        <li>
                            <p>계</p>
                        </li>
                    </ul>
                    <div className="body_table">
                        <div className="inner_table_wrap">
                            {data.map((item, index) => (
                                <div className="wrap_table_item" >
                                    <div className="inner_table_item table_item_01">
                                        <p className="cont_table_item">{item.title}</p>
                                    </div>
                                    {item.months.map((month, monthIndex) => (
                                        <div className={`inner_table_item table_item_${(2 + monthIndex).toString().padStart(2, '0')}`}>
                                            <p className="cont_table_item">{month}</p>
                                        </div>
                                    ))}
                                    <div className="inner_table_item table_item_14">
                                        <p className="cont_table_item">{item.total}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}